import { useNavigate } from "react-router-dom";

const SourceSwitcher = ({ active }) => {
  const navigate = useNavigate();

  const sources = [
    { key: "internal", label: "Internal DB", path: "/admin/internal-db" },
    { key: "ceipal", label: "Ceipal", path: "/admin/ceipal-db" },
  ];

  return (
    <div className="flex gap-2 mb-6">
      {sources.map((s) => (
        <button
          key={s.key}
          onClick={() => navigate(s.path)}
          className={`px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors
            ${
              active === s.key
                ? "bg-white text-[#012760] border-white"
                : "bg-white/10 text-white/70 border-white/20 hover:bg-white/20"
            }`}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
};

export default SourceSwitcher;